import React, { useEffect } from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import QrCode from "../../../../../../Images/qrCode1.png";
import QuickTixLogo from "../../../../../../Images/GX_Logo_Black_No_Bg.png";
import moment from "moment";

const Template1 = ({
  ticket,
  ChangeColor,
  type,
  image,
  bookerName,
  navigator,
}) => {
  const qrCodeData = ticket?.qrCode || "";
  const pevSelected = Number(ticket?.prevTicket) === ticket?.id ? true : false;
  useEffect(() => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = ticket?.qrCode;
  }, [ticket?.qrCode]);

  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        height: "100%",
        border: pevSelected ? "2px solid #4A90E2" : "0px solid #e0e0e0",
        boxShadow: pevSelected
          ? "0 4px 12px rgba(74, 144, 226, 0.5)"
          : "0 2px 8px rgba(0, 0, 0, 0.1)",
        transition: "all 0.1s ease",
        "&:hover": {
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
          border: "1px solid #4A90E2",
          borderRadius: "1px",
        },
        backgroundColor: ChangeColor
          ? ChangeColor
          : ticket?.bgColor
          ? ticket?.bgColor
          : "#e8e8e8",
        // minWidth: "450px",
        justifyContent: "space-around",
      }}
    >
      <Stack
        direction={"column"}
        width={"65%"}
        sx={{
          borderRight: "3px dotted black",
        }}
        // "#F5F0E8"
      >
        <Stack
          flex={1}
          display={"flex"}
          direction={"row"}
          justifyContent={"space-between"}
          mt={3}
        >
          <img
            crossOrigin="anonymous"
            src={image ? image : QuickTixLogo}
            alt="QR"
            style={{
              width: "25%",
              maxHeight: "80px",
              maxWidth: "80%",
              height: "auto",
              objectFit: "contain",
              marginLeft: "2%",
            }}
          />

          <Typography
            variant="body2"
            sx={{
              fontSize: {
                xs: "0.65rem",
                sm: "1rem",
              },
              fontFamily: "Bebas Neue",
            }}
            mr={"1rem"}
          >
            {bookerName ? bookerName : ticket?.organizer}
          </Typography>
        </Stack>
        <Stack flex={5} direction={"row"} pb={"1rem"} pr={"3%"}>
          <Stack flex={{ lg: 3, md: 2, sm: 2, xs: 2 }} my={"auto"}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 400,
                fontSize: {
                  xs: "0.8rem",
                  sm: "1rem",
                  md: "1.3rem",
                  lg: "1.6rem",
                },
                maxWidth: "170px",
                my: "auto",
                fontFamily: "Alatsi",
              }}
              ml={2}
            >
              {ticket?.title}
            </Typography>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 400,
                fontSize: {
                  xs: "0.65rem",
                  sm: "0.7rem",
                  md: "0.75rem",
                  lg: "0.8rem",
                },
                maxWidth: "170px",
                mt: "0.5em",
                fontFamily: "Sora",
              }}
              ml={2}
            >
              {moment(ticket?.date).format("MM/DD/YYYY")} &nbsp;&nbsp;&nbsp;{" "}
              {ticket?.time}
            </Typography>
          </Stack>

          <Stack
            flex={1}
            direction={"column"}
            justifyContent={"flex-end"}
            pr={1.5}
          >
            <Stack alignItems={"end"}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: "0.7rem", sm: "1.6rem" },
                  whiteSpace: "nowrap",
                  fontFamily: "Lato",
                  fontWeight: 600,
                }}
              >
                {/* {type ? type : "VIP"} */}
                {type ? type : ticket?.type?.[0]?.typeName ?? "VIP"}
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "0.7rem", sm: "1rem" },
                  color: "#737373",
                  fontFamily: "Lato",
                  fontWeight: 400,
                }}
                variant="caption"
              >
                {ticket?.ticketName ? ticket?.ticketName : "Ticket"}
              </Typography>
              ${""}
              {ticket?.price != null && ticket?.price !== ""
                ? ticket?.ticketPrices
                  ? Object.values(ticket?.ticketPrices)[0]
                  : Number(ticket?.price) === 0
                  ? "Free"
                  : Number(ticket?.price) % 1 === 0
                  ? Number(ticket?.price).toFixed(0)
                  : ticket.price
                : "211"}
            </Stack>
          </Stack>
        </Stack>

        <Stack flex={1} direction={"row"}>
          <Stack>
            <Typography
              variant="body2"
              sx={{
                fontSize: { xs: "0.7rem", sm: "0.9rem" },
                fontFamily: "Lato",
              }}
              m={1}
            >
              {ticket?.location}
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Box
        alignItems={"center"}
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
        width={"25%"}
        justifyContent={"center"}
        position={"relative"}
        gap={"0.5rem"}
      >
        <Typography
          variant="h6"
          sx={{
            fontSize: {
              xs: "0.6rem",
              sm: "0.875rem",

              color: "#191919",
              fontFamily: "Lato",
            },
          }}
        >
          {ticket?.code}
        </Typography>
        {navigator === "ct" ? (
          <></>
        ) : !qrCodeData ? (
          <img
            crossOrigin="anonymous"
            src={QrCode}
            alt="qr"
            style={{
              width: "100%",
              maxWidth: "80%",
              height: "auto",
              maxHeight: "80px",
              objectFit: "contain",
            }}
          />
        ) : (
          <img
            crossOrigin="anonymous"
            src={ticket?.qrCode || QrCode}
            alt="QR"
            style={{
              width: "100%",
              maxWidth: "100%",
              height: "auto",
              maxHeight: "100px",
              objectFit: "contain",
            }}
          />
        )}
        <Stack ml={2} mt={1}>
          <img
            crossOrigin="anonymous"
            src={QuickTixLogo}
            alt="Logo"
            style={{
              width: "100%",
              maxWidth: "80%",
              height: "auto",
              maxHeight: "30px",
              objectFit: "contain",
            }}
          />
        </Stack>
      </Box>
    </Paper>
  );
};

export default Template1;
